import { Component, OnInit, Input } from '@angular/core';
import { VehicleBusinessService } from '../../../../business-services/vehicle-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { VehicleOwnershipHistoryDetailsModel } from '../../../../business-entities/vehicle-ownership-history-model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-vehicle-ownership-history',
  templateUrl: './vehicle-ownership-history.component.html'
})
export class VehicleOwnershipHistoryComponent implements OnInit {
@Input() licensePlate: string
vehicleOwnershipRequestModel={
  LicensePlate: '',
  StartRecordNumber: 0,
  PageSize: 25
};
vehicleOwnershipHistoryList: VehicleOwnershipHistoryDetailsModel[] = [];
totalCount: number = 0;
throttle = 100;
scrollDistance = 1;
  constructor(
    private vehicleBusinessService: VehicleBusinessService,
    private spinner: NgxSpinnerService,
    private activeModal: NgbActiveModal
  ) { }

  ngOnInit(): void {
    this.vehicleOwnershipRequestModel.LicensePlate = this.licensePlate;
    this.vehicleOwnershipRequestModel.StartRecordNumber = 0
    this.GetVehicleOwnershipHistory();
  }

  GetVehicleOwnershipHistory() {
    this.spinner.show();
    this.vehicleBusinessService
      .GetVehicleOwnershipHistory( this.vehicleOwnershipRequestModel )
      .then((response) => {
        if (response) {
          this.vehicleOwnershipHistoryList.push(...response);
          this.totalCount = this.vehicleOwnershipHistoryList[0].totalCount;
          this.spinner.hide();
        } else {
          this.spinner.hide();
        }
      });
  }
  OnClose() {
    this.activeModal.dismiss('Cross click');
  }
  onScrollDown(_ev) {
    if(this.totalCount > this.vehicleOwnershipHistoryList.length){
      this.vehicleOwnershipRequestModel.StartRecordNumber = this.vehicleOwnershipHistoryList.length;
      this.GetVehicleOwnershipHistory();
    }
  }
}
